import styled from "styled-components";

export const StreamRow = styled.div.attrs(({ start, zIndex }) => ({
    style: {
        transform: `translateY(${start}px)`,
        zIndex: `${zIndex}`,
    }
}))`
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 0;
  width: 100%;
`;

export const StreamCol = styled.div`
  align-items: stretch;
  flex-direction: column;
  height: ${({ totalSize }) => totalSize}px;
  position: relative;
`;